<template>
<div>
    <marquee-text :duration="50" :repeat="10" @mouseover="stopMarquee" :paused='paused' @mouseleave="startMarquee">
    <div class="latest-news-marquee-area">
        <div class="simple-marquee-container">
            <div class="marquee">
                <ul class="marquee-content-items">
                    <li v-for="marquee in marquees" :key="marquee.id">
                        <a :href="'https://bharatsamachartvnews.com/single-post/'+marquee.id" target="_blank"><span class="latest-news-time">{{marquee.postdate|Time}}</span>
                {{marquee.title|truncate(100)}}</a>
                    </li>
                    
                </ul>
            </div>
        </div>
    </div>
    </marquee-text>
    
</div>
</template>

<script>
import Mainaxios from '../Api'
  export default {
    name: 'Marquee',
    data: () => ({
        marquees:[],
        paused:false,
      
    }),
    created () {
        this.fetchData()
    },
    methods:{
        async fetchData(){
            await Mainaxios.get("https://admin.bharatsamachartvnews.com/api/marquee").then(({data}) => (this.marquees = data));
        },
        stopMarquee(){
            this.paused = true;
        },
        startMarquee(){
            this.paused = false;
        },
        getEpaper(id){
            this.$router.push('/epaper/'+id)
        }
    }
  }
</script>

<style scoped>
.covid-row{
    background: #101010;
    color: #fff;
    margin-top: -7px;
    padding: 14px;
    text-align: center;
}
.simple-marquee-container {
    width: 100%;
    display: inline-block;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    z-index: 1;
    height: 65px;
}

.marquee-content-items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0;
    position: relative;
    z-index: 1;
    height: 65px;
}

.marquee-content-items li {
    background-color: #101010;
    padding: 0 20px;
    height: 65px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.marquee-content-items li:nth-child(even) {
    background-color: #1c1c1c;
}

.marquee-content-items li a {
    font-size: 18px;
    color: #fff;
    display: inline-block;
    text-decoration: none;
}

.marquee-content-items li a > span {
    background-color: #ff0303;
    padding: 2px 6px;
    font-size: 14px;
    font-weight: 300;
    margin-right: 20px;
}

</style>